<template>
    <b-modal 
        @ok="importedMeters.length > 0 ? handleValidation($event) : handleOk($event)"
        @hidden="resetModal"
        :visible="show" 
        :title="$t('ImportMeters')" 
        :ok-title="importedMeters.length > 0 ? $t('Validate') : $t('Import')"
        :cancel-title="$t('Cancel')"
        centered
        no-close-on-esc
        no-close-on-backdrop
        :ok-disabled="!file || loading"
        :busy="loading">
        <!-- EN TETE DE LA MODAL -->
        <template #modal-header="{close}">
            <b-col cols="3">
                <!-- BOUTON DE FERMETURE -->
                <b-icon-arrow-left role="button" font-scale="1" @click="show = false; close();" v-b-tooltip.hover :title="$t('Back')"/> 
            </b-col>
            <b-col cols="3" class="text-right">
                <!-- BOUTON DE FERMETURE -->
                <b-icon-x-lg role="button" font-scale="1" @click="show = false; close();" v-b-tooltip.hover :title="$t('Close')" />
            </b-col>
        </template>
        <b-form-group
            :label="$t('LabelRaeImport')"
            label-for="file-input"
            :description="$t('DescriptionRaeImport')">
            <b-form-file
                @change="resetModal"
                v-model="file"
                :state="Boolean(file)"
                :placeholder="$t('PlaceholderRaeImport')"
                :drop-placeholder="$t('DropPlaceholderRaeImport')"
                accept=".xlsx, .xls, .csv, .txt, text/plain, text/csv"
                :browse-text="$t('BrowseTextRaeImport')"/>
        </b-form-group>
        <p v-if="file && errors.length > 0" class="mt-2">
            <strong>{{$t('ErrorNumber')}}</strong> : {{ errors.length }}
        </p>
        <p v-if="file && importedMeters.length > 0" class="mt-2">
            <strong>{{$t('ImportedNumber')}}</strong> : {{ importedMeters.length }}
        </p>
        <b-alert v-for="(error, index) in errors" :key="index" show variant="danger" class="mt-2">
            {{ error }}
        </b-alert>
    </b-modal>
</template>
<script lang="ts">

    /**
     * Composants Vue js
     */
    import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
    import { mixins } from 'vue-class-component';

    /**
     * Traductions
     */
    import locale from '../../../locales/SMA.json';

    /**
     * Classes
     */
    import { Meter } from '@/types/Administration/SMA/MetersInformations';
    import { SMACertificate } from '@/types/Administration/SMA/SMACertificate';

    /**
     * Utilitaire
     */
    import { SMAUtils } from '../../SMAUtils';
    
	@Component({
        i18n:{messages:locale}
	})
    /**
     * Composant d'importation de compteurs suivant un fichier csv, xslx, txt
     */
	export default class RAEImport extends mixins(Vue, SMAUtils) {

        /**
         * Affichage de la fenêtre
         */
        @PropSync('Show', { default: false })
        private show!: boolean;
        
        /**
         * Mandat distributeur
         */
        @Prop()
        public Certificate!: SMACertificate;

        /**
         * Type objet (Compteur Gaz, Electrique ...)
         */
        @Prop({ default: () => [] })
        private Types!: string[];

        /**
         * Fichier d'import
         */
        private file: any = null;

        /**
         * Chargement en cours
         */
        private loading: boolean = false;

        /**
         * Liste des erreurs
         */
        private errors: string[] = [];

        /**
         * Liste des compteurs importés
         */
        private importedMeters: Array<Meter> = [];

        /**
         * Réinitialisation de la fenêtre
         */
        private resetModal() :void 
        {
            this.file = null;
            this.errors = [];
            this.loading = false;
            this.importedMeters = [];
        }
    
        /**
         * Importation des compteurs à partir d'un fichier
         * @param bvModalEvent Modal
         */
        private async handleOk(bvModalEvent : any) : Promise<void>
        {
            bvModalEvent.preventDefault();

            if (!this.file) return;

            this.loading = true;
            this.errors = [];

            this.$store.dispatch('CertificateStore/ImportRaeList', { item: this.Certificate, file: this.file, types: this.Types }).then((result) => 
            {
                this.showToast(result.message, result.success ? "success" : "danger", "Import");
                
                this.errors = result.data.Errors || [];
                this.importedMeters = result.data.Meters || [];
            }).catch((error) => {
                console.error(error);
                this.errors = ["Erreur lors de l'envoi ou du traitement du fichier."];
            }).finally(() => {
                this.loading = false;
            });
        }

        /**
         * Validation de l'importation des compteurs
         */
        private handleValidation(bvModalEvent : any) :void 
        {
            this.$emit('OnValidation', this.importedMeters);
            this.show = false;
        }
};
</script>